import { NgModule } from '@angular/core';
import { MeetingAnalysisRoutingModule } from './meeting-analysis-routing.module';
import { MeetingListService } from './meeting-list.service';

@NgModule({
  imports: [MeetingAnalysisRoutingModule],
  providers: [MeetingListService],
})
export class MeetingAnalysisModule {}
